import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setActiveDrawing } from '../../store/actions';
import MenuCloseButton from './MenuCloseButton';

export class DrawMenuComponent extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.handleChangeShape(event.target.value);
    this.props.onCloseClick();
  }

  render() {
    const {
      onCloseClick,
      draw,
    } = this.props;
    const radioOptions = [
      'None',
      'Circle',
      'Rectangle',
      'Polygon',
    ];
    return (
      <div className="map-toolbar__menu map-toolbar--demographics">
        <MenuCloseButton onCloseClick={onCloseClick} />
        <div className="toolbox-content filter-box">
          <h4>Choose Shape:</h4>
          <form>
            { radioOptions.map(option => (
              <div className="map-toolbar__option" key={option}>
                <input
                  type="radio"
                  className="radio--custom"
                  id={option}
                  name={option}
                  value={option === 'None' ? '' : option}
                  checked={(draw === '' && option === 'None') || draw === option}
                  onChange={this.handleChange}
                />
                <label htmlFor={option}>{option}</label>
              </div>
            ))}
          </form>
        </div>
      </div>
    );
  }
}

DrawMenuComponent.propTypes = {
  draw: PropTypes.string.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  handleChangeShape: PropTypes.func.isRequired,
};

/* istanbul ignore next */
export const mapStateToProps = state => {
  return {
    draw: state.draw,
  };
};

/* istanbul ignore next */
export const mapDispatchToProps = dispatch => {
  return {
    handleChangeShape: shapeType => { dispatch(setActiveDrawing(shapeType)); },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawMenuComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/DrawMenu.js